import React from 'react';
import { cn } from '../../../../utils/tailwind';
import { TariffFeaturesItem } from './item/tariff-features-item';

interface TariffFeaturesProps {
    data: Array<string>;
    locked?: boolean;
    forPartners?: boolean;
    className?: string;
}

export const TariffFeatures: React.FC<TariffFeaturesProps> = ({
    data,
    locked = false,
    forPartners = false,
    className,
}) => {
    return (
        <div
            className={cn(
                'tariff-features-list flex w-full flex-col',
                forPartners ? 'gap-[2.4rem]' : 'gap-[1.6rem]',
                className,
            )}
        >
            {data.map((item, index) => (
                <TariffFeaturesItem key={index} value={item} locked={locked} forPartners={forPartners} />
            ))}
        </div>
    );
};
